// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
export const VERSION = {
  dirty: false,
  raw: 'b86ba91',
  hash: 'b86ba91',
  distance: null,
  tag: null,
  semver: null,
  suffix: 'b86ba91',
  semverString: null,
  version: '13.9.0'
};
